import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { WistiaWindow } from '@shared/wistia/wistia-window.model';
import { WistiaService } from './wistia.service';

@Component({
  selector: 'zbp-wistia',
  templateUrl: './wistia.component.html',
  styleUrls: ['./wistia.component.scss'],
  standalone: false
})
export class WistiaComponent implements OnInit {
  @Input() isModal = false;
  @Input() wistiaCode: string;
  @Output() videoEnded: EventEmitter<void> = new EventEmitter<void>();
  @Output() videoError: EventEmitter<void> = new EventEmitter<void>();
  @Output() videoReady: EventEmitter<void> = new EventEmitter<void>();

  private video: any;

  constructor(private activeModal: NgbActiveModal, private wistia: WistiaService) { }

  ngOnInit(): void {
    this.wistia.loadScript()
      .subscribe((loaded) => {
        if (loaded) {
          this.initialize();
        }
      });
  }

  dismiss(): void {
    if (this.isModal) {
      this.activeModal.dismiss();
    }
  }

  private initialize() {
    const w: WistiaWindow = window;
    w._wq.push({
      id: this.wistiaCode,
      options: { autoPlay: true },
      onHasData: (video) => {
        this.video = video;
        this.video.chrome.focus();
        this.video.chrome.setAttribute('tabindex', '0');

        video.bind('play', () => video.unbind);
        video.bind('end', () => {
          this.video.chrome.setAttribute('video', '-1');
          this.videoEnded.emit();
        });
        video.bind('error', () => {
          this.videoError.emit();
        });
      },
      onReady: () => {
        this.videoReady.emit();
      },
    });
  }
}
